import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PagesExpenditurePage } from './pages-expenditure';

@NgModule({
  declarations: [
    PagesExpenditurePage,
  ],
  imports: [
    IonicPageModule.forChild(PagesExpenditurePage),
  ],
})
export class PagesExpenditurePageModule {}



// WEBPACK FOOTER //
// ./src/pages/pages-expenditure/pages-expenditure.module.ts